import React from "react";

const PropertyIllustration = ({ className }: { className?: string }) => {
  return (
    <svg
      width="294"
      height="233"
      viewBox="0 0 294 233"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M183.41 232.203L294 168.34L110.591 62.4287L0 126.291L183.41 232.203Z"
        fill="#133345"
      />
      <path
        d="M289.864 168.34L110.594 64.8175L4.14062 126.288L183.412 229.812L289.864 168.34Z"
        fill="#26808F"
      />
      <path
        d="M149.018 209.04L182.103 189.934L216.492 209.793L183.406 228.899L149.018 209.04ZM110.969 148.858L141.483 166.478L108.398 185.583L77.8836 167.963L110.969 148.858ZM213.246 125.037L181.131 143.582L150.618 125.962L182.733 107.417L213.246 125.037ZM221.751 167.039L253.866 148.494L288.255 168.352L256.139 186.897L221.751 167.039ZM219.323 168.442L253.712 188.299L218.92 208.391L184.531 188.532L219.323 168.442ZM183.559 144.984L215.673 126.439L251.437 147.092L219.323 165.637L183.559 144.984ZM143.911 165.076L113.397 147.455L148.19 127.364L178.703 144.984L143.911 165.076ZM179.676 188.532L146.59 207.638L110.825 186.986L143.911 167.879L179.676 188.532ZM146.339 166.478L181.131 146.387L216.895 167.039L182.103 187.13L146.339 166.478ZM215.688 123.642L215.681 123.63L215.674 123.635L182.733 104.611L73.0273 167.963L183.406 231.703L293.111 168.352L215.688 123.642Z"
        fill="#F0EFFB"
      />
      <path
        d="M30.6758 90.8872V93.0808C30.7447 93.6881 31.2004 94.3224 32.0692 94.8188C33.2557 95.5085 34.8695 95.7708 36.2352 95.5639C36.8139 95.4814 37.3521 95.3158 37.7935 95.0534L62.5395 80.7602C63.1878 80.4018 63.4914 79.9055 63.5191 79.3943L63.5326 77.2561L61.9601 77.3805C60.2773 76.4838 57.8359 76.4006 56.4148 77.2283L35.4482 89.3285L31.9867 91.3288L31.9177 90.8872H30.6758Z"
        fill="#C7784C"
      />
      <path
        d="M30.6758 90.8872V93.0808C30.7447 93.6881 31.2004 94.3224 32.0692 94.8188C33.2557 95.5085 34.8695 95.7708 36.2352 95.5639V89.3285H35.4482L31.9867 91.3288L31.9177 90.8872H30.6758Z"
        fill="#DFCFB5"
      />
      <path
        d="M37.7917 92.9868L62.5434 78.6936C64.0103 77.8466 63.8259 76.3672 62.1322 75.3893V75.3887C60.4385 74.4108 57.8766 74.3051 56.4098 75.1521L31.6581 89.4453C30.1912 90.2923 30.3756 91.7717 32.0693 92.7496C33.763 93.7275 36.3249 93.8338 37.7917 92.9868Z"
        fill="white"
      />
      <path
        d="M149.258 87.5923L149.25 87.5788L149.242 87.5826L110.951 65.4709L5.13281 126.413L138.135 203.188L243.952 142.246L149.258 87.5923Z"
        fill="#E3FBFF"
      />
      <path
        d="M243.952 139.191L215.059 122.506V105.659L243.952 122.344V139.191ZM5.13281 123.079V93.6019L30.4968 78.9555V97.0951V108.696L5.13281 123.079Z"
        fill="url(#paint0_linear_1185_34753)"
      />
      <path
        d="M243.952 142.238L215.059 125.56V123.279L215.674 123.635L215.681 123.631L215.688 123.642L243.952 139.965V142.238Z"
        fill="url(#paint1_linear_1185_34753)"
      />
      <path
        d="M76.6965 92.6016L30.4961 65.9227L104.662 23.0651L150.863 49.7446L76.6965 92.6016Z"
        fill="#9ADAE4"
      />
      <path
        d="M76.6953 147.922V92.6025L150.861 49.7456V105.065L76.6953 147.922Z"
        fill="#57C1D2"
      />
      <path
        d="M97.2502 133.492L81.0625 142.84V106.078L97.2502 96.7308V133.492Z"
        fill="#F7F7FD"
      />
      <path
        d="M30.4961 121.243V65.9236L76.6964 92.6025V147.922L30.4961 121.243Z"
        fill="#9ADAE4"
      />
      <path
        d="M36.7539 79.091V114.659L42.9391 118.223V82.6544L36.7539 79.091Z"
        fill="#F7F7FD"
      />
      <path
        d="M45.4062 84.0832V119.651L51.5908 123.215V87.6467L45.4062 84.0832Z"
        fill="#F7F7FD"
      />
      <path
        d="M54.0586 89.0753V124.644L60.2438 128.207V92.6394L54.0586 89.0753Z"
        fill="#F7F7FD"
      />
      <path
        d="M62.7148 94.0715V129.639L68.8994 133.203V97.6356L62.7148 94.0715Z"
        fill="#F7F7FD"
      />
      <path
        d="M165.17 115.367L100.973 78.5355L150.859 49.741L215.057 86.5733L165.17 115.367Z"
        fill="#57C1D2"
      />
      <path
        d="M165.172 170.734V115.371L215.058 86.5766V141.94L165.172 170.734Z"
        fill="#57C1D2"
      />
      <path
        d="M100.973 133.902V78.5389L165.17 115.371V170.734L100.973 133.902Z"
        fill="#9ADAE4"
      />
      <path
        d="M160.745 164.285L105.398 132.325V95.733L160.745 127.694V164.285Z"
        fill="#F7F7FD"
      />
      <path
        d="M89.0772 92.3633L86.5508 89.4979L98.0491 82.8532L100.974 84.5311V85.772L89.0772 92.3633Z"
        fill="#133345"
      />
      <path
        d="M100.973 85.7695V84.5289L100.978 84.5321L100.978 85.7663L100.973 85.7695Z"
        fill="#013BA1"
      />
      <path
        d="M28.5469 66.4238L55.3777 59.2614L129.544 16.4038L102.714 23.5662L28.5469 66.4238Z"
        fill="#5598E9"
      />
      <path
        d="M77.9032 94.4961L55.3789 59.2624L129.546 16.4048L152.069 51.6385L77.9032 94.4961Z"
        fill="#3F461D"
      />
      <path
        d="M152.069 49.0458V51.6385L77.9023 94.4961V91.9028L152.069 49.0458Z"
        fill="#57C1D2"
      />
      <path
        d="M62.0001 78.3887L53.5708 66.4381L37.5559 69.9996L30.4961 65.923L31.8031 65.5556L55.3793 59.2622L66.7236 77.0073L62.0001 78.3887Z"
        fill="#133345"
      />
      <path
        d="M30.498 71.5684L30.4961 65.9221L37.5558 69.9987L30.498 71.5684Z"
        fill="#133345"
      />
      <path
        d="M31.8047 65.5547L55.2777 58.9596L55.3808 59.1214V59.2613L31.8047 65.5547Z"
        fill="#073CAE"
      />
      <path
        d="M28.5469 63.832L55.3777 56.6703L129.544 13.8127L102.714 20.9745L28.5469 63.832Z"
        fill="#DDF3F6"
      />
      <path
        d="M77.9032 91.9023L55.3789 56.6693L129.546 13.8117L152.069 49.0454L77.9032 91.9023Z"
        fill="#9ADAE4"
      />
      <path
        d="M92.9971 72.6523L80.2852 68.1084L80.2864 59.7599L90.8587 63.6638L95.6472 69.0741L92.9971 72.6523Z"
        fill="#133345"
      />
      <path
        d="M80.2873 59.1133L75.6914 56.4594L80.2589 53.8216L84.8548 56.4761L80.2873 59.1133Z"
        fill="#9ADAE4"
      />
      <path
        d="M80.2845 59.0898L75.3477 56.238L80.2535 53.4049L85.191 56.2561L80.2845 59.0898Z"
        fill="#DDF3F6"
      />
      <path
        d="M80.2852 59.9473L85.1917 57.1135V56.2562L80.2852 59.0899V59.9473Z"
        fill="#133345"
      />
      <path
        d="M75.3477 57.0961L80.2845 59.9473V59.0899L75.3477 56.2381V57.0961Z"
        fill="#9ADAE4"
      />
      <path
        d="M83.5117 56.4717L80.2809 58.3418L80.2705 58.3308L77.0391 56.4614L80.2596 54.6023L80.2705 54.6133L83.5117 56.4717Z"
        fill="#133345"
      />
      <path
        d="M83.5107 56.4718L80.2798 58.3418L80.2695 58.3308V54.6133L83.5107 56.4718Z"
        fill="#9ADAE4"
      />
      <path
        d="M80.2852 68.1094L84.8527 65.4722V56.4778L80.2852 59.115V68.1094Z"
        fill="#133345"
      />
      <path
        d="M75.6914 60.9683L80.2866 68.1094V59.115L75.6914 56.4611V60.9683Z"
        fill="#9ADAE4"
      />
      <path
        d="M80.2857 54.3691L79.6367 53.994L80.2812 53.6222L80.9302 53.9966L80.2857 54.3691Z"
        fill="#9ADAE4"
      />
      <path
        d="M80.2891 58.8711L80.9336 58.4991V53.9971L80.2891 54.3697V58.8711Z"
        fill="#133345"
      />
      <path
        d="M79.6367 58.4966L80.2857 58.8711V54.3697L79.6367 53.9945V58.4966Z"
        fill="#9ADAE4"
      />
      <path
        d="M80.2892 54.3691L79.8516 54.1165L80.2814 53.8696L80.7229 54.1184L80.2892 54.3691Z"
        fill="#096EA8"
      />
      <path
        d="M80.2936 55.75L80.2891 55.7474V54.3695L80.7228 54.1188L80.9316 54.2361V55.3833L80.2936 55.75Z"
        fill="#093B7D"
      />
      <path
        d="M80.287 55.748L79.6406 55.3717V54.2367L79.8494 54.1175L80.287 54.3701V55.748Z"
        fill="#096EA8"
      />
      <path
        d="M84.2115 52.1016L83.5625 51.7271L84.207 51.3546L84.8566 51.729L84.2115 52.1016Z"
        fill="#9ADAE4"
      />
      <path
        d="M84.2109 56.6035L84.8561 56.2316V51.7295L84.2109 52.1021V56.6035Z"
        fill="#133345"
      />
      <path
        d="M83.5625 56.229L84.2115 56.6035V52.1021L83.5625 51.7276V56.229Z"
        fill="#9ADAE4"
      />
      <path
        d="M84.2104 52.1016L83.7695 51.8476L84.0518 51.682L84.4901 51.9398L84.2104 52.1016Z"
        fill="#096EA8"
      />
      <path
        d="M84.2109 53.4863V52.1026L84.4907 51.9408L84.8561 52.1554V53.1138L84.2109 53.4863Z"
        fill="#093B7D"
      />
      <path
        d="M84.2071 53.4863L83.5664 53.1886V51.966L83.7688 51.8474L84.2096 52.1013V53.485L84.2071 53.4863Z"
        fill="#096EA8"
      />
      <path
        d="M76.3411 52.0898L75.6914 51.7154L76.3365 51.3429L76.9856 51.718L76.3411 52.0898Z"
        fill="#9ADAE4"
      />
      <path
        d="M76.3398 56.5918L76.9843 56.2192V51.7178L76.3398 52.0898V56.5918Z"
        fill="#133345"
      />
      <path
        d="M75.6914 56.2166L76.3411 56.5918V52.0898L75.6914 51.7152V56.2166Z"
        fill="#9ADAE4"
      />
      <path
        d="M76.3395 52.0898L76.0508 51.9236L76.4858 51.6696L76.772 51.8404L76.3395 52.0898Z"
        fill="#096EA8"
      />
      <path
        d="M76.3398 53.4727V52.0902L76.7723 51.8408L76.9824 51.9665V53.1137L76.3398 53.4727Z"
        fill="#093B7D"
      />
      <path
        d="M76.3392 53.4746L75.6953 53.1021V52.1328L76.0524 51.9253L76.3411 52.0915V53.474L76.3392 53.4746Z"
        fill="#096EA8"
      />
      <path
        d="M80.2899 54.3633L74.8594 51.2272L80.2557 48.1111L85.6862 51.2465L80.2899 54.3633Z"
        fill="white"
      />
      <path
        d="M80.2891 55.3066L85.6854 52.1899V51.2468L80.2891 54.3636V55.3066Z"
        fill="#9ADAE4"
      />
      <path
        d="M74.8594 52.1706L80.2899 55.3066V54.3636L74.8594 51.2275V52.1706Z"
        fill="#DDF3F6"
      />
      <path
        d="M162.21 119.668L98.0117 82.8356L118.093 64.1416L182.291 100.974L162.21 119.668Z"
        fill="#5598E9"
      />
      <path
        d="M153.922 51.0505L130.355 42.5164L194.554 79.3487L218.12 87.8828L153.922 51.0505Z"
        fill="#DDB79B"
      />
      <path
        d="M194.556 79.3495L182.292 100.973L118.094 64.1403L130.357 42.5172L194.556 79.3495Z"
        fill="#433E44"
      />
      <path
        d="M165.174 122.59L165.172 116.908V122.536L165.174 122.534V122.59Z"
        fill="#02288E"
      />
      <path
        d="M165.174 122.59L100.98 85.7678V84.534L162.212 119.664L165.172 116.908V122.589"
        fill="#133345"
      />
      <path
        d="M100.98 80.0723V78.5687L101.084 78.5094L102.059 79.0688L100.98 80.0723Z"
        fill="#02288E"
      />
      <path
        d="M100.98 78.5664V78.4472L101.084 78.5068L100.98 78.5664Z"
        fill="#0852BE"
      />
      <path
        d="M162.212 119.668L100.98 84.5381V80.0741L102.059 79.0704L165.174 115.274L165.172 116.912L162.212 119.668Z"
        fill="#073CAE"
      />
      <path
        d="M169.527 112.855L182.292 100.973L194.556 79.3494L193.462 78.7222L194.556 79.3494L214.846 86.6975L208.812 90.1803L194.556 85.024L183.269 104.923L169.527 112.855Z"
        fill="#133345"
      />
      <path
        d="M165.172 122.535V116.907L169.527 112.854L183.269 104.921L182.291 106.645L165.172 122.535ZM215.054 92.4365L208.811 90.1784L214.845 86.6956L215.054 86.771V92.4365Z"
        fill="#133345"
      />
      <path
        d="M165.174 116.91V115.273L165.172 111.687L178.845 98.9955L182.293 100.974L169.529 112.857L165.174 116.91Z"
        fill="#033093"
      />
      <path
        d="M215.055 86.127L194.473 74.3182L194.555 74.1738L215.055 84.2157V86.127Z"
        fill="url(#paint2_linear_1185_34753)"
      />
      <path
        d="M215.056 86.7734L214.847 86.698L194.557 79.35L193.464 78.7228L194.557 76.796L193.434 76.1514L194.474 74.3161L215.056 86.1249V86.7734Z"
        fill="#073962"
      />
      <path
        d="M182.291 100.973L178.844 98.9943L180.544 97.4156L182.291 98.418L193.462 78.7223L194.555 79.3495L182.291 100.973Z"
        fill="#02132B"
      />
      <path
        d="M165.172 122.539V116.911L165.174 116.909V122.537L165.172 122.539Z"
        fill="#000D5A"
      />
      <path
        d="M165.172 116.91V115.271L165.174 115.272V116.908L165.172 116.91Z"
        fill="#00136E"
      />
      <path
        d="M162.21 117.113L98.0117 80.2803L118.093 61.587L182.291 98.4193L162.21 117.113Z"
        fill="#9ADAE4"
      />
      <path
        d="M153.922 48.4919L130.355 39.9584L194.554 76.7907L218.12 85.3242L153.922 48.4919Z"
        fill="#9ADAE4"
      />
      <path
        d="M194.556 76.7955L182.292 98.418L118.094 61.5863L130.357 39.9632L194.556 76.7955Z"
        fill="#DDF3F6"
      />
      <path
        d="M55.3777 56.6688V59.2614L28.5469 66.4238V63.8305L55.3777 56.6688Z"
        fill="#9ADAE4"
      />
      <path
        d="M55.3789 56.6698V59.2624L77.9032 94.4961V91.9028L55.3789 56.6698Z"
        fill="#9ADAE4"
      />
      <path
        d="M218.123 87.8849V85.3303L194.557 76.7968L182.293 98.42L162.211 117.114V119.668L182.293 100.974L194.557 79.3508L218.123 87.8849Z"
        fill="#133345"
      />
      <path
        d="M162.21 119.668V117.114L98.0117 80.281V82.8356L162.21 119.668Z"
        fill="#9ADAE4"
      />
      <path
        d="M136.05 68.8262V55.614L132.426 53.5197L131.672 46.4282H136.05L149.518 53.9284L149.289 55.8699L145.833 61.493L136.05 68.8262Z"
        fill="#133345"
      />
      <path
        d="M140.468 53.5957V61.0882L136.051 68.8262V55.614L140.468 53.5957Z"
        fill="#133345"
      />
      <path
        d="M136.05 68.8262L127.293 63.7653V50.5538L136.05 55.614V68.8262Z"
        fill="#9ADAE4"
      />
      <path
        d="M134.822 55.3164L124.977 49.6263L131.833 45.7908L141.679 51.4809L134.822 55.3164Z"
        fill="#DDF3F6"
      />
      <path
        d="M134.822 54.8789L124.977 49.1882L131.833 45.3527L141.679 51.0428L134.822 54.8789Z"
        fill="white"
      />
      <path
        d="M135.483 56.375L140.468 53.5948L141.681 51.4798L134.824 55.3152L135.483 56.375Z"
        fill="#133345"
      />
      <path
        d="M124.977 49.6252L125.635 50.6843L135.48 56.375L134.822 55.3152L124.977 49.6252Z"
        fill="#9ADAE4"
      />
      <path
        d="M134.824 55.3164V54.8781L141.681 51.0419V51.4809L134.824 55.3164Z"
        fill="#9ADAE4"
      />
      <path
        d="M134.822 55.3164V54.8781L124.977 49.1874V49.6263L134.822 55.3164Z"
        fill="#DDF3F6"
      />
      <path
        d="M128.07 63.5453V53.0625L135.272 57.2184V67.7012L128.07 63.5453Z"
        fill="#9ADAE4"
      />
      <path
        d="M128.914 54.5281V63.059L134.428 66.2363V57.7054L128.914 54.5281Z"
        fill="white"
      />
      <path
        d="M129.864 55.0767V62.6548L134.428 65.2829V66.2363L128.914 63.0596V54.5281L129.864 55.0767Z"
        fill="#133345"
      />
      <path
        d="M129.864 62.6548L128.914 63.0596L134.428 66.2363V65.2829L129.864 62.6548Z"
        fill="#DDF3F6"
      />
      <path
        d="M130.567 63.0586H128.914L129.864 62.6538V55.0756L130.585 55.4901L130.567 63.0586Z"
        fill="#0C59BE"
      />
      <path
        d="M154.546 79.418L151.406 68.6683L150.168 57.02H154.546L168.014 64.5202L167.785 66.4617L164.328 72.0848L154.546 79.418Z"
        fill="#133345"
      />
      <path
        d="M158.964 64.1869V71.6799L154.547 79.418V66.2065L158.964 64.1869Z"
        fill="#133345"
      />
      <path
        d="M154.546 79.418L145.789 74.3571V61.1456L154.546 66.2065V79.418Z"
        fill="#9ADAE4"
      />
      <path
        d="M153.319 65.9102L143.473 60.2201L150.329 56.3846L160.175 62.0753L153.319 65.9102Z"
        fill="#DDF3F6"
      />
      <path
        d="M153.319 65.4688L143.473 59.7787L150.329 55.9432L160.175 61.6333L153.319 65.4688Z"
        fill="white"
      />
      <path
        d="M153.978 66.9688L158.963 64.1878L160.176 62.0741L153.32 65.909L153.978 66.9688Z"
        fill="#133345"
      />
      <path
        d="M143.473 60.2189L144.131 61.278L153.977 66.9688L153.319 65.909L143.473 60.2189Z"
        fill="#9ADAE4"
      />
      <path
        d="M153.32 65.9102V65.4712L160.176 61.6357V62.0753L153.32 65.9102Z"
        fill="#9ADAE4"
      />
      <path
        d="M153.319 65.9102V65.4712L143.473 59.7811V60.2201L153.319 65.9102Z"
        fill="#DDF3F6"
      />
      <path
        d="M146.566 74.1391V63.6562L153.769 67.8121V78.2949L146.566 74.1391Z"
        fill="#9ADAE4"
      />
      <path
        d="M147.41 65.1218V73.6527L152.924 76.8301V68.2992L147.41 65.1218Z"
        fill="white"
      />
      <path
        d="M148.36 65.6704V73.2492L152.924 75.8767V76.8301L147.41 73.6534V65.1218L148.36 65.6704Z"
        fill="#133345"
      />
      <path
        d="M148.36 73.2492L147.41 73.6534L152.924 76.8301V75.8767L148.36 73.2492Z"
        fill="#DDF3F6"
      />
      <path
        d="M147.41 73.6523H149.063L149.082 66.0839L148.36 65.6694V73.2482L147.41 73.6523Z"
        fill="#133345"
      />
      <path
        d="M173.043 90.0117L169.903 79.262L168.664 67.6138H173.043L186.51 75.1139L186.281 77.0555L182.824 82.6785L173.043 90.0117Z"
        fill="#133345"
      />
      <path
        d="M177.46 74.7813V82.2743L173.043 90.0117V76.8002L177.46 74.7813Z"
        fill="#133345"
      />
      <path
        d="M173.043 90.0117L164.285 84.9508V71.7393L173.043 76.8002V90.0117Z"
        fill="#9ADAE4"
      />
      <path
        d="M171.814 76.502L161.969 70.8119L168.826 66.9764L178.671 72.6671L171.814 76.502Z"
        fill="#DDF3F6"
      />
      <path
        d="M171.814 76.0645L161.969 70.3744L168.826 66.5389L178.671 72.2296L171.814 76.0645Z"
        fill="white"
      />
      <path
        d="M172.475 77.5625L177.46 74.7823L178.673 72.6679L171.816 76.5028L172.475 77.5625Z"
        fill="#133345"
      />
      <path
        d="M161.969 70.8127L162.627 71.8718L172.473 77.5625L171.814 76.5027L161.969 70.8127Z"
        fill="#9ADAE4"
      />
      <path
        d="M171.816 76.502V76.063L178.673 72.2281V72.6671L171.816 76.502Z"
        fill="#9ADAE4"
      />
      <path
        d="M171.814 76.502V76.063L161.969 70.3729V70.8119L171.814 76.502Z"
        fill="#DDF3F6"
      />
      <path
        d="M165.062 84.7315V74.248L172.265 78.4039V88.8867L165.062 84.7315Z"
        fill="#9ADAE4"
      />
      <path
        d="M165.906 75.7142V84.2445L171.42 87.4219V78.8909L165.906 75.7142Z"
        fill="white"
      />
      <path
        d="M166.856 76.2622V83.841L171.419 86.4685V87.4219L165.906 84.2452V75.7136L166.856 76.2622Z"
        fill="#133345"
      />
      <path
        d="M166.856 83.841L165.906 84.2452L171.419 87.4219V86.4685L166.856 83.841Z"
        fill="#DDF3F6"
      />
      <path
        d="M165.906 84.2461H167.559L167.577 76.6776L166.856 76.2631V83.8419L165.906 84.2461Z"
        fill="#133345"
      />
      <path
        d="M284.06 144.445L232.395 114.61V111.953L284.06 141.788V144.445Z"
        fill="#133345"
      />
      <path
        d="M284.062 144.445L285.23 143.772V141.114L284.062 141.788V144.445Z"
        fill="#004899"
      />
      <path
        d="M285.228 141.112L284.06 141.785L232.395 111.95L233.563 111.277L285.228 141.112Z"
        fill="#9ADAE4"
      />
      <path
        d="M284.06 169.824L232.395 139.99V137.332L284.06 167.166V169.824Z"
        fill="#133345"
      />
      <path
        d="M284.062 169.824L285.23 169.151V166.493L284.062 167.166V169.824Z"
        fill="#004899"
      />
      <path
        d="M285.228 166.49L284.06 167.164L232.395 137.33L233.563 136.656L285.228 166.49Z"
        fill="#9ADAE4"
      />
      <path
        d="M239.244 147.652L235.109 145.265V108.082L237.176 106.76L239.244 110.469V147.652Z"
        fill="#9ADAE4"
      />
      <path
        d="M239.242 147.652L240.451 146.958V109.775L239.242 110.469V147.652Z"
        fill="#133345"
      />
      <path
        d="M239.243 110.469L240.452 109.775L238.386 106.067L237.176 106.76L239.243 110.469Z"
        fill="#DDF3F6"
      />
      <path
        d="M238.066 117.584C238.066 118.149 237.667 118.377 237.174 118.092C236.681 117.808 236.281 117.118 236.281 116.553C236.281 115.987 236.681 115.759 237.174 116.044C237.667 116.329 238.066 117.018 238.066 117.584Z"
        fill="#004899"
      />
      <path
        d="M238.066 142.193C238.066 142.759 237.667 142.986 237.174 142.701C236.681 142.417 236.281 141.728 236.281 141.162C236.281 140.597 236.681 140.369 237.174 140.653C237.667 140.937 238.066 141.627 238.066 142.193Z"
        fill="#004899"
      />
      <path
        d="M245.907 151.504L241.773 149.117V111.934L243.84 110.612L245.907 114.321V151.504Z"
        fill="#9ADAE4"
      />
      <path
        d="M245.91 151.504L247.119 150.81V113.627L245.91 114.321V151.504Z"
        fill="#133345"
      />
      <path
        d="M245.907 114.324L247.116 113.631L245.049 109.921L243.84 110.616L245.907 114.324Z"
        fill="#DDF3F6"
      />
      <path
        d="M244.734 121.438C244.734 122.004 244.335 122.232 243.842 121.948C243.349 121.663 242.949 120.974 242.949 120.408C242.949 119.843 243.349 119.615 243.842 119.899C244.335 120.184 244.734 120.873 244.734 121.438Z"
        fill="#004899"
      />
      <path
        d="M244.734 146.044C244.734 146.61 244.335 146.838 243.842 146.553C243.349 146.269 242.949 145.58 242.949 145.014C242.949 144.448 243.349 144.22 243.842 144.505C244.335 144.789 244.734 145.479 244.734 146.044Z"
        fill="#004899"
      />
      <path
        d="M252.575 155.359L248.441 152.972V115.789L250.508 114.467L252.575 118.176V155.359Z"
        fill="#9ADAE4"
      />
      <path
        d="M252.574 155.359L253.784 154.665V117.482L252.574 118.176V155.359Z"
        fill="#133345"
      />
      <path
        d="M252.575 118.176L253.784 117.482L251.717 113.773L250.508 114.467L252.575 118.176Z"
        fill="#DDF3F6"
      />
      <path
        d="M251.399 125.294C251.399 125.86 251 126.088 250.507 125.803C250.014 125.519 249.613 124.829 249.613 124.263C249.613 123.698 250.014 123.47 250.507 123.755C251 124.039 251.399 124.729 251.399 125.294Z"
        fill="#004899"
      />
      <path
        d="M251.399 149.904C251.399 150.469 251 150.697 250.507 150.413C250.014 150.127 249.613 149.438 249.613 148.872C249.613 148.307 250.014 148.079 250.507 148.363C251 148.648 251.399 149.338 251.399 149.904Z"
        fill="#004899"
      />
      <path
        d="M259.243 159.215L255.109 156.828V119.644L257.176 118.323L259.243 122.031V159.215Z"
        fill="#9ADAE4"
      />
      <path
        d="M259.242 159.215L260.452 158.521V121.338L259.242 122.031V159.215Z"
        fill="#133345"
      />
      <path
        d="M259.243 122.027L260.452 121.334L258.385 117.625L257.176 118.319L259.243 122.027Z"
        fill="#DDF3F6"
      />
      <path
        d="M258.066 129.146C258.066 129.711 257.666 129.94 257.174 129.655C256.681 129.37 256.281 128.681 256.281 128.116C256.281 127.549 256.681 127.322 257.174 127.607C257.666 127.891 258.066 128.58 258.066 129.146Z"
        fill="#004899"
      />
      <path
        d="M258.066 153.755C258.066 154.321 257.666 154.549 257.174 154.264C256.681 153.98 256.281 153.29 256.281 152.724C256.281 152.159 256.681 151.931 257.174 152.216C257.666 152.5 258.066 153.189 258.066 153.755Z"
        fill="#004899"
      />
      <path
        d="M265.908 163.066L261.773 160.679V123.496L263.841 122.174L265.908 125.883V163.066Z"
        fill="#9ADAE4"
      />
      <path
        d="M265.91 163.066L267.12 162.372V125.19L265.91 125.883V163.066Z"
        fill="#133345"
      />
      <path
        d="M265.907 125.887L267.116 125.194L265.049 121.485L263.84 122.178L265.907 125.887Z"
        fill="#DDF3F6"
      />
      <path
        d="M264.734 133.001C264.734 133.567 264.334 133.795 263.842 133.51C263.349 133.226 262.949 132.536 262.949 131.971C262.949 131.405 263.349 131.177 263.842 131.462C264.334 131.746 264.734 132.436 264.734 133.001Z"
        fill="#004899"
      />
      <path
        d="M264.734 157.607C264.734 158.173 264.334 158.4 263.842 158.116C263.349 157.831 262.949 157.142 262.949 156.576C262.949 156.01 263.349 155.783 263.842 156.068C264.334 156.352 264.734 157.042 264.734 157.607Z"
        fill="#004899"
      />
      <path
        d="M272.575 166.922L268.441 164.535V127.352L270.508 126.03L272.575 129.739V166.922Z"
        fill="#9ADAE4"
      />
      <path
        d="M272.574 166.922L273.784 166.229V129.045L272.574 129.739V166.922Z"
        fill="#133345"
      />
      <path
        d="M272.575 129.738L273.784 129.045L271.718 125.336L270.508 126.03L272.575 129.738Z"
        fill="#DDF3F6"
      />
      <path
        d="M271.402 136.857C271.402 137.422 271.003 137.65 270.509 137.366C270.017 137.081 269.617 136.392 269.617 135.827C269.617 135.261 270.017 135.033 270.509 135.318C271.003 135.602 271.402 136.291 271.402 136.857Z"
        fill="#004899"
      />
      <path
        d="M271.402 161.462C271.402 162.028 271.003 162.256 270.509 161.971C270.017 161.686 269.617 160.997 269.617 160.432C269.617 159.866 270.017 159.638 270.509 159.923C271.003 160.207 271.402 160.896 271.402 161.462Z"
        fill="#004899"
      />
      <path
        d="M279.243 170.777L275.109 168.39V131.207L277.176 129.885L279.243 133.594V170.777Z"
        fill="#9ADAE4"
      />
      <path
        d="M279.242 170.777L280.451 170.083V132.9L279.242 133.594V170.777Z"
        fill="#133345"
      />
      <path
        d="M279.243 133.59L280.452 132.896L278.385 129.188L277.176 129.881L279.243 133.59Z"
        fill="#DDF3F6"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1185_34753"
          x1="124.543"
          y1="44.1092"
          x2="124.543"
          y2="108.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFCF7" />
          <stop offset="1" stopColor="#9ADAE4" stopOpacity="0.21" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1185_34753"
          x1="124.543"
          y1="44.1096"
          x2="124.543"
          y2="108.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8E6F9" />
          <stop offset="1" stopColor="#E1FBFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1185_34753"
          x1="124.541"
          y1="44.1119"
          x2="124.541"
          y2="108.582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0850A1" />
          <stop offset="1" stopColor="#074CA1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PropertyIllustration;
